import React from 'react';

import { MenuSection } from 'features/menu/pages/menu-object-page/menu-section';
import { MenuSection as MenuSectionBadgesExperiment } from 'features/menu/pages/menu-object-page/menu-section/menu-section-badges-experiment';
import { MenuSectionPage } from 'features/menu/pages/menu-section-page/menu-section-page';
import { useStoreRequired } from 'features/store/hooks/use-store-required';
import { View } from 'react-native';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { useAcceleratorBadgesOnMenuExperiment } from 'experiments/use-accelerator-badges-on-menu-experiment';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';

export default function MenuSectionPageById() {
  useStoreRequired();

  return <MenuSectionInner />;
}

const MenuSectionInner = React.memo(() => {
  const enableUnifiedMenu = useEnableUnifiedMenu();
  const enableMenuAcceratorBadgesExperiment = useAcceleratorBadgesOnMenuExperiment(true);
  return (
    <View testID="menu-section-page" style={{ flex: 1 }}>
      {enableUnifiedMenu ? (
        <MenuSectionPage />
      ) : enableMenuAcceratorBadgesExperiment ? (
        <MenuSectionBadgesExperiment />
      ) : (
        <MenuSection />
      )}
      <FloatingViewCartFab safeAreaBottom />
    </View>
  );
});
